import { ButtonBase } from "@components/Button";
import XIconSVG from "@components/svgs/x-icon.svg";
import { Dispatch, SetStateAction } from "react";
import { media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import AdUnit from ".";

const AdArea = styled.div`
  padding: ${pxToRem(10)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => `linear-gradient(308deg, ${theme.grey_500} 0%, black 135%)`};

  ${media.mobile} {
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 10001;
    width: 100%;
  }
`;

const AdWrapper = styled.div`
  flex: 0 1 ${pxToRem(728)};
  min-height: ${pxToRem(90)};

  ${media.mobile} {
    flex: 0 1 ${pxToRem(320)};
    min-height: ${pxToRem(50)};
  }
`;

const CloseIcon = styled.button`
  display: none;
  ${media.mobile} {
    ${ButtonBase}
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: ${pxToRem(-14)};
    right: 0px;
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    padding: ${pxToRem(1)} ${pxToRem(6)};
    background-color: ${({ theme }) => theme.grey_700};
    border: 1px solid ${({ theme }) => theme.grey_300};
    border-radius: 50%;
    color: white;

    svg {
      width: 100%;
      height: 100%;
    }

    &:focus-visible,
    :focus-within,
    :active,
    :focus {
      position: absolute;
    }
  }
`;

interface Props {
  setShouldShowAd: Dispatch<SetStateAction<boolean>>;
}
export default function TopBannerAd({ setShouldShowAd }: Props) {
  return (
    <AdArea>
      <AdWrapper>
        <CloseIcon onClick={() => setShouldShowAd(false)}>
          <XIconSVG />
        </CloseIcon>
        <AdUnit id="ad_bnr_atf_01" />
      </AdWrapper>
    </AdArea>
  );
}
